import { createContext, ReactNode, useContext, useEffect, useState } from "react";
import { Country } from "../models/Country";
import utilsService from "../services/UtilsService";

interface AppContextValue {
  countries: Country[];
}

const defaultValue: AppContextValue = {
  countries: [],
};

const AppContext = createContext<AppContextValue>(defaultValue);

export function AppProvider({ children }: { children: ReactNode }) {
  const [countries, setCountries] = useState<Country[]>([]);

  useEffect(() => {
    utilsService.getCountries().then(setCountries);
  }, []);

  return (
    <AppContext.Provider value={{ countries }}>
      {children}
    </AppContext.Provider>
  );
}

export function useAppContext() {
  return useContext(AppContext);
}
